import React from "react"
import { StaticQuery, graphql } from "gatsby"
import remark from 'remark';
import recommended from 'remark-preset-lint-recommended';
import remarkHtml from 'remark-html';
import module from '../../gatsby-config.js';


function correct(guide){
  if(guide.includes("](/") && typeof module.pathPrefix != "undefined"){
    let text = String(guide);
    text = text.replace(/(\[[\w\d\s\n.:/\\\-"?=*–]*\]\()(\/[\w\d\s\n.:/\\\-"?=*–]*\))/g, "$1...$2".replace("...", module.pathPrefix));
    return text;
  }
}

export class Instructions extends React.Component{
  constructor(props){
    super(props);
    const guide = props.data.allMarkdownRemark.edges[0].node.frontmatter.keywords_guide;
    this.state = {guide: guide}
    this.state.guide = correct(this.state.guide);
  }

  render(){

    return (
      <div style={{padding:`15px 0px`}} dangerouslySetInnerHTML={{ __html: remark().use(recommended).use(remarkHtml).processSync(this.state.guide).toString() }}></div>
    )
  }

}


export default props => (
  <StaticQuery
    query={graphql`
      query keywords_instructions{
        allMarkdownRemark(filter: {frontmatter: {keywords_filter: {eq: true}}}){
          edges{
            node{
              frontmatter{
                keywords_guide
              }
            }
          }
        }
      }`}
    render={data => <Instructions data={data} {...props} />}
  />
)
